import { differenceInMinutes } from 'date-fns';
export var $sessionTimeout = {
  pendingIntervals: [],
  /**
   * run a handler on session timeout
   *
   * @param {function} handler
   * @param {number} sessionTimeout [minutes]
   */
  onTimeout: function onTimeout(handler, sessionTimeout) {
    var startTime = new Date();
    var screenInterval = setInterval(function () {
      var minutes = differenceInMinutes(new Date(), startTime);
      if (minutes >= sessionTimeout) {
        handler();
        clearInterval(screenInterval);
      }
    }, 1000);
    this.pendingIntervals.push(screenInterval);
  },
  /**
   * clear all intervals
   */
  clearAllPendingIntervals: function clearAllPendingIntervals() {
    this.pendingIntervals.forEach(function (interval) {
      clearInterval(interval);
    });
  }
};